import { HelperInitializer } from '../Helper/HelperInitializer';

export class PopupInitializer {
	static init = () => {
		const popup = document.getElementById('delo-popup-container')!;
		const closeButton = popup.querySelector('.close-popup')!;

		const popupTrigger = document.querySelectorAll<HTMLElement>('.delo-popup-trigger');

		popupTrigger.forEach((trigger) => {
			trigger.addEventListener('click', (e) => {
				e.preventDefault();
				e.stopPropagation();
				this.open(popup, trigger.getAttribute('data-popup-content')!);
			});
		});

		closeButton.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();
			this.close(popup);
		});
	};

	static open = (popup: HTMLElement, content: string) => {
		popup.querySelector('.popup-content')!.innerHTML = content;
		popup.setAttribute('aria-hidden', 'false');
		popup.style.display = 'flex';
		HelperInitializer.lockScroll();
	};

	static close = (popup: HTMLElement) => {
		popup.setAttribute('aria-hidden', 'true');
		popup.style.display = 'none';
		HelperInitializer.unlockScroll();
	};
}
